import { CLEAR_FOCUS_AREA_MAP } from './index';

export const clearFocusAreaMapAction = (focus_area_map) => ({
    type: CLEAR_FOCUS_AREA_MAP,
    focus_area_map
});